export const GET_COMMON_ORDER_SUCCESS = 'GET_COMMON_ORDER_SUCCESS';
export const ASSIGN_USER_ORDER_SUCCESS = 'ASSIGN_USER_ORDER_SUCCESS';
export const RESET_ORDER_STATES = 'RESET_ORDER_STATES';
export const REFRESH_STITCH_IMAGES_STATUS = 'REFRESH_STITCH_IMAGES_STATUS';

export const GET_ORDERID_BY_NUMBER_SUCCESS = 'GET_ORDERID_BY_NUMBER_SUCCESS';
